"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3796],{

/***/ 81887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AccountMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__(5341);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/contexts/UserContext.tsx + 2 modules
var UserContext = __webpack_require__(8060);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-avatar/es/index.js + 32 modules
var es = __webpack_require__(28039);
;// CONCATENATED MODULE: ./src/components/Marketing/AccountSwitcherButton.tsx




// import Icon from '@components/Reusables/Design/Icon'



// import { HiSelector } from 'react-icons/hi'
var AccountSwitcherButton = function(props) {
    var ref = (0,UserContext/* useUserContext */.SE)(), username = ref.username, tmp = ref.data, ref1 = tmp === void 0 ? {
        isContact: {
            name: undefined
        },
        hasEmail: {
            email: undefined
        }
    } : tmp, name = ref1.isContact.name, email = ref1.hasEmail.email, tmp1 = ref.settings, ref2 = tmp1 === void 0 ? {
        profilePic: {
            value: undefined
        }
    } : tmp1, tmp2 = ref2.profilePic, ref3 = tmp2 === void 0 ? {
        value: undefined
    } : tmp2, pic = ref3.value;
    var bg = (0,dist_index_esm/* useColorModeValue */.ff)("mb_steel.400", "gray.700");
    var bgActive = (0,dist_index_esm/* useColorModeValue */.ff)("mb_steel.500", "gray.600");
    var subTextColor = (0,dist_index_esm/* useColorModeValue */.ff)("mb_steel.700", "gray.400");
    var buttonProps = (0,index_esm/* useMenuButton */.zZ)(props);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "button"
    }, buttonProps), {
        //   w='full'
        display: "flex",
        alignItems: "center",
        rounded: "lg",
        bg: bg,
        px: "3",
        py: "2",
        fontSize: "sm",
        userSelect: "none",
        cursor: "pointer",
        outline: "0",
        transition: "all 0.2s",
        _active: {
            bg: bgActive
        },
        _focus: {
            shadow: "outline"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
            flex: "1",
            spacing: "3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                    round: true,
                    size: "24px",
                    src: pic,
                    name: name,
                    email: pic ? null : email,
                    alt: "Profile Picture"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                    textAlign: "start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                            noOfLines: 1,
                            fontWeight: "semibold",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                            fontSize: "xs",
                            color: subTextColor,
                            children: username
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Marketing_AccountSwitcherButton = (AccountSwitcherButton);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Marketing/AccountMenu.tsx


// import UserProfileLink from '@components/MainHeader/UserProfileLink'
// import NextLink from 'next/link'


// import Image from 'next/image'

var Account = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var user = (0,UserContext/* useUserContext */.SE)();
    var logout = user.logout;
    // const loggedIn = user.token !== null
    // const name = user?.data?.isContact?.name
    // const pic = user?.settings?.profilePic?.value
    var email = user === null || user === void 0 ? void 0 : (ref = user.data) === null || ref === void 0 ? void 0 : (ref1 = ref.hasEmail) === null || ref1 === void 0 ? void 0 : ref1.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Menu */.v2, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing_AccountSwitcherButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* MenuList */.qy, {
                shadow: "lg",
                py: "4",
                color: (0,dist_index_esm/* useColorModeValue */.ff)("gray.600", "gray.200"),
                px: "3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                        fontWeight: "medium",
                        mb: "2",
                        children: email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuDivider */.R, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* MenuGroup */.kS, {
                        title: "Tools",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                                value: "contacts",
                                fontWeight: "semibold",
                                rounded: "md",
                                onClick: function() {
                                    return router.push("/contacts");
                                },
                                children: "Contacts"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                                value: "tasks",
                                fontWeight: "semibold",
                                rounded: "md",
                                onClick: function() {
                                    return router.push("/tasks");
                                },
                                children: "Tasks"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                                value: "calendar",
                                fontWeight: "semibold",
                                rounded: "md",
                                onClick: function() {
                                    return router.push("/calendar");
                                },
                                children: "Calendar"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                                value: "finances",
                                fontWeight: "semibold",
                                rounded: "md",
                                onClick: function() {
                                    return router.push("/finances");
                                },
                                children: "Finances"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuDivider */.R, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                        value: "home",
                        fontWeight: "semibold",
                        rounded: "md",
                        onClick: function() {
                            window.location.href = "/home";
                        },
                        children: "missionbase.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuDivider */.R, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                        rounded: "md",
                        onClick: function() {
                            return router.push("/settings");
                        },
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MenuItem */.sN, {
                        rounded: "md",
                        onClick: function() {
                            return logout();
                        },
                        children: "Logout"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AccountMenu = (Account);


/***/ }),

/***/ 85742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* unused harmony export features */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52494);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63750);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89583);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60155);



// import { features } from './data'



var FeatureList = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "section",
        bg: "bg-surface",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            py: {
                base: "16",
                md: "24"
            },
            maxW: "full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                spacing: {
                    base: "12",
                    md: "16"
                },
                m: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                        spacing: {
                            base: "4",
                            md: "5"
                        },
                        align: "center",
                        textAlign: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                                spacing: "3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        fontSize: {
                                            base: "sm",
                                            md: "md"
                                        },
                                        fontWeight: "semibold",
                                        color: "accent",
                                        children: "More Features"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                        size: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useBreakpointValue */ .Sx)({
                                            base: "sm",
                                            md: "md"
                                        }),
                                        children: "What else can it do?"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                // color='muted'
                                fontSize: {
                                    base: "lg",
                                    md: "xl"
                                },
                                maxW: "3xl",
                                children: "Built from the ground up with flexibility in mind to fit your workflow, no matter who you are."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MI, {
                        columns: {
                            base: 1,
                            md: 2,
                            lg: 3
                        },
                        columnGap: 8,
                        rowGap: {
                            base: 10,
                            md: 16
                        },
                        children: features.map(function(feature) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                                spacing: {
                                    base: "4",
                                    md: "5"
                                },
                                align: "center",
                                textAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Square */ .bK, {
                                        size: {
                                            base: "10",
                                            md: "12"
                                        },
                                        bg: "accent",
                                        color: "inverted",
                                        borderRadius: "lg",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                            as: feature.icon,
                                            boxSize: {
                                                base: "5",
                                                md: "6"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                                        spacing: {
                                            base: "1",
                                            md: "2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                                fontSize: {
                                                    base: "lg",
                                                    md: "xl"
                                                },
                                                fontWeight: "medium",
                                                children: feature.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                                color: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useColorModeValue */ .ff)("gray.600", "gray.400"),
                                                children: feature.description
                                            })
                                        ]
                                    })
                                ]
                            }, feature.name);
                        })
                    })
                ]
            })
        })
    });
};
var features = [
    {
        name: "Tasks",
        description: "Connect tasks to directly to contacts, and filter them by attributes of the contact. What?!",
        icon: react_icons_bs__WEBPACK_IMPORTED_MODULE_6__/* .BsStars */ .nfF
    },
    {
        name: "Integrated Calendar",
        description: "The most powerful calendar you've ever used.",
        icon: react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoRocketSharp */ .u8_
    },
    {
        name: "Auto-Dialer",
        description: 'Curate your list of contacts and hit "Go" to automatically call them directly from your browser. When you are done, the next call rings automatically! No more start-stop.',
        icon: react_icons_bs__WEBPACK_IMPORTED_MODULE_6__/* .BsFillMoonFill */ .mox
    },
    {
        name: "Connect. All the ways.",
        description: "Dont just call. Text. Email. Send newsletters. Social media messaging. Spice it up. All from a single interface.",
        icon: react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaPaintBrush */ ._TT
    },
    {
        name: "Financial Integrations",
        description: "Connect your finances directly to your contacts, tasks, and calendar and enable powerful reporting and planning.",
        icon: react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaExpandAlt */ .U9w
    },
    {
        name: "Much much more...",
        description: "Use your time to serve others, not bogged down in administrative duties. More time away from your computer means more time to accomplish your mission.",
        icon: react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaAccessibleIcon */ .Eys
    }, 
];


/***/ }),

/***/ 67958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ Features; }
/* harmony export */ });
/* unused harmony exports FeatureSection, BulletList */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8395);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23887);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5434);






function FeatureSection(props) {
    var reverse = props.reverse, title = props.title, subtitle = props.subtitle, button = props.button, img = props.img, component = props.component, list = props.list;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "section",
        bg: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useColorModeValue */ .ff)("gray.50", "gray.800"),
        py: "10",
        overflow: "hidden",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
            maxW: {
                base: "xl",
                md: "7xl"
            },
            mx: "auto",
            px: {
                base: "6",
                md: "8"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                align: "flex-start",
                direction: {
                    base: "column",
                    lg: reverse ? "row-reverse" : "row"
                },
                // justify='space-between'
                justify: "space-evenly",
                mb: "10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        flex: "1",
                        maxW: {
                            lg: "xl"
                        },
                        pt: "6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                as: "h2",
                                size: "2xl",
                                mt: "8",
                                fontWeight: "extrabold",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                color: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useColorModeValue */ .ff)("gray.600", "gray.400"),
                                mt: "5",
                                fontSize: "xl",
                                children: subtitle
                            }),
                            list && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BulletList, {
                                list: list
                            }),
                            button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                mt: "8",
                                minW: "14rem",
                                colorScheme: "pink",
                                size: "lg",
                                height: "14",
                                px: "8",
                                fontSize: "md",
                                fontWeight: "bold",
                                children: button === null || button === void 0 ? void 0 : button.text
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .Ei, {
                        pos: "relative",
                        marginEnd: reverse ? null : "-16rem",
                        marginStart: reverse ? {
                            base: null,
                            lg: "-16rem"
                        } : null,
                        borderRadius: 10,
                        w: "40rem",
                        src: img === null || img === void 0 ? void 0 : img.src,
                        alt: img === null || img === void 0 ? void 0 : img.alt
                    })
                ]
            })
        })
    });
}
function Features() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: featureSections.map(function(feature, i) {
            var reverse = feature.reverse;
            var flip = !!(reverse !== null && reverse !== void 0 ? reverse : i % 2) // automatically alternates layout for every other item
            ;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, feature), {
                reverse: flip
            }), i);
        })
    });
}
var featureSections = [
    {
        title: "Contact info that is always up-to-date",
        subtitle: "Outdated address books are a thing of the past. Benefit from data that is always up to date so you can get right to work without having to worry if your data is good.",
        // img: { src: '/images/undraw_resume_1hqp.svg', alt: 'screenshot' },
        img: {
            src: "/images/undraw_personal_data_re_ihde.svg",
            alt: "screenshot"
        },
        // component: () => <BulletList list={['te']} />,
        list: [
            "Contact that is effortlessly correct",
            "Data points that are verified by humans",
            "Privacy aware with private and group sharing options",
            "Intelligent data enrichment that fills in missing pieces automatically",
            "Enable/Disable groups of contacts to focus on your target", 
        ]
    },
    {
        title: "Social and Collaborative",
        subtitle: "Outdated address books are a thing of the past. Benefit from data that is always up to date so you can get right to work without having to worry if your data is good.",
        img: {
            src: "/images/undraw_online_connection_6778.svg",
            alt: "screenshot"
        },
        // component: () => <BulletList list={['te']} />,
        list: [
            "Create groups to work with",
            "Share private notes and contact info only with group",
            "Join groups for additional data points that are relevant to the group",
            "See and share activity of those in your organization (optional)",
            "Activity heatmaps for each contact", 
        ]
    },
    {
        title: "Powerful Automations",
        subtitle: "Power through your work with less friction.",
        img: {
            src: "/images/undraw_done_re_oak4.svg",
            alt: "screenshot"
        },
        list: [
            "Auto-Dialer right from the browser",
            "Send physical postcards with a click",
            "Email Templates that work with any email address",
            "Send newsletter templates with a click",
            "Workflows and Pipline management", 
        ]
    },
    {
        title: "Integrates with you",
        subtitle: "Integrations with industry standard formats ensure that you will be able to use and work with your data no matter where you are.",
        img: {
            src: "/images/undraw_mind_map_re_nlb6.svg",
            alt: "screenshot"
        },
        list: [
            "Syncs natively with all of your devices and apps",
            "Unified financial view",
            "See your calendar and contacts anywhere",
            "Additional integrations available through our API, and more coming all the time", 
        ]
    },
    {
        title: "Dashboards",
        subtitle: "Visualize and analyze your progress.",
        img: {
            src: "/images/undraw_charts_re_5qe9.svg",
            alt: "screenshot"
        },
        list: [
            "Project your goal date",
            "Find meanigful metrics to analyze ways to improve efficiency",
            "Stay motivated by seeing your team's progress",
            "Daily dashboard to show you exactly what has happend and where to get started",
            "Financial dashboard to efficively plan and budget", 
        ]
    },
    {
        title: "Powerful segmentation",
        subtitle: "Find connections with our social graph that combines 100+ data points on any contact or organization. ",
        img: {
            src: "/images/undraw_filter_re_sa16.svg",
            alt: "screenshot"
        },
        list: [
            "Create complex nested filters based on deeply nested attributes",
            "Save complex filters that are unique to you",
            "Easily combine & toggle saved filters to quickly include or exclude results",
            "Filter by any relationship or attribute--or relationships of relationships",
            "Join other groups to access even more niche data points", 
        ]
    }, 
];
var BulletList = function(props) {
    var list = props.list;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .List */ .aV, {
        spacing: 3,
        py: 10,
        ml: 5,
        children: list === null || list === void 0 ? void 0 : list.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .ListIcon */ .DE, {
                        as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdCheckCircle */ .ZSR,
                        color: "green.500"
                    }),
                    item
                ]
            }, item);
        })
    });
};


/***/ }),

/***/ 27173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Header; }
/* harmony export */ });
/* unused harmony exports Header2, AccountSwitcher */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contexts_UserContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8060);
/* harmony import */ var _AccountMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81887);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8395);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23887);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5341);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86893);
/* harmony import */ var _components_Reusables_Logic_SaveColorMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92467);




// import TrueFalse from '@components/Reusables/Logic/TrueFalse'




// import { Logo } from './Logo'
function Header() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        className: "header",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header2, {})
    });
};
var Nav = function() {
    var logoURL = useColorModeValue("https://missionbase-resources.s3.amazonaws.com/website/rocket+black+mb.png", "https://missionbase-resources.s3.amazonaws.com/website/rocket+white+mb.png");
    var user = useUserContext();
    var loggedIn = user.token !== null;
    return /*#__PURE__*/ _jsxs(Flex, {
        className: "nav",
        // bg='white'
        mx: [
            10,
            null,
            20
        ],
        mt: [
            10
        ],
        children: [
            /*#__PURE__*/ _jsx(Box, {
                mr: 5,
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "/",
                    children: /*#__PURE__*/ _jsx(Image, {
                        alt: "MissionBase Logo",
                        src: logoURL,
                        height: 31,
                        quality: 100
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {}),
            /*#__PURE__*/ _jsx(Menus, {
                links: links
            })
        ]
    });
};
var links = [
    {
        name: "Home",
        to: "/"
    },
    // {
    //   name: 'About',
    //   to: '/about',
    // },
    {
        name: "Features",
        to: "/features"
    },
    {
        name: "Pricing",
        to: "/pricing"
    }, 
];
var Menus = function(props) {
    var links = props.links;
    return links.map(function(link) {
        return /*#__PURE__*/ _jsx(Text, {
            mr: 5,
            children: /*#__PURE__*/ _jsx(NextLink, {
                href: link.to,
                children: /*#__PURE__*/ _jsx(Box, {
                    children: link.name
                })
            })
        }, link.name);
    });
};
var Header2 = function() {
    var logoURL = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .useColorModeValue */ .ff)("https://missionbase-resources.s3.amazonaws.com/website/rocket+black+mb.png", "https://missionbase-resources.s3.amazonaws.com/website/rocket+white+mb.png");
    var isDesktop = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .useBreakpointValue */ .Sx)({
        base: false,
        lg: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        as: "section",
        pb: {
            base: "12",
            md: "24"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
            as: "nav",
            bg: "bg-surface",
            boxShadow: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .useColorModeValue */ .ff)("sm", "sm-dark"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
                py: {
                    base: "4",
                    lg: "5"
                },
                maxW: "7xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .HStack */ .Ug, {
                    spacing: "10",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Image */ .Ee, {
                                alt: "MissionBase Logo",
                                src: logoURL,
                                height: 31,
                                quality: 100
                            })
                        }),
                        isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                            justify: "space-between",
                            flex: "1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ButtonGroup */ .hE, {
                                    variant: "link",
                                    spacing: "8",
                                    children: links.map(function(item) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: item.to,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx, {
                                                children: item.name
                                            })
                                        }, item.to);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .HStack */ .Ug, {
                                    spacing: "3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusables_Logic_SaveColorMode__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            type: "icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/contacts",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx, {
                                                variant: "outline",
                                                children: "Sign in"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccountSwitcher, {})
                        })
                    ]
                })
            })
        })
    });
};
var AccountSwitcher = function() {
    // const { isOpen, onToggle } = useDisclosure()
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu */ .v2, {
        // isOpen={ isOpen }
        closeOnBlur: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuButton */ .j2, {
                as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .IconButton */ .hU,
                "aria-label": "Options",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiMenu */ .cur, {
                    fontSize: "1.25rem"
                }),
                variant: "outline"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuList */ .qy, {
                shadow: "lg",
                py: "4",
                color: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .useColorModeValue */ .ff)("gray.600", "gray.200"),
                px: "3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/home",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuItem */ .sN, {
                            rounded: "md",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/features",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuItem */ .sN, {
                            rounded: "md",
                            children: "Features"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/pricing",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuItem */ .sN, {
                            rounded: "md",
                            children: "Pricing"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuDivider */ .R, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/contacts",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .MenuItem */ .sN, {
                            rounded: "md",
                            children: "Sign in"
                        })
                    })
                ]
            })
        ]
    });
} // https://missionbase-resources.s3.amazonaws.com/website/white.png
 // https://missionbase-resources.s3.amazonaws.com/website/Black.png
 // https://missionbase-resources.s3.amazonaws.com/website/Black+Logo.png
 // https://missionbase-resources.s3.amazonaws.com/website/White+Logo.png
 // https://missionbase-resources.s3.amazonaws.com/website/White+logo+mobile.png
 // https://missionbase-resources.s3.amazonaws.com/website/White+mobile.png
;


/***/ })

}]);